module.exports = __webpack_public_path__ + "03_glasses_blue.a036e708.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer4/03_glasses_blue.png
// module id = Z0ec
// module chunks = 0